const PlayIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g id="play">
        <path
          id="Icon"
          d="M4.16675 4.15797C4.16675 3.34866 4.16675 2.94401 4.33549 2.72095C4.48249 2.52663 4.70718 2.40638 4.95041 2.39186C5.22961 2.37519 5.5663 2.59965 6.23968 3.04857L15.0026 8.89054C15.5591 9.26148 15.8373 9.44695 15.9342 9.68072C16.019 9.8851 16.019 10.1148 15.9342 10.3192C15.8373 10.5529 15.5591 10.7384 15.0026 11.1093L6.23968 16.9513C5.5663 17.4002 5.22961 17.6247 4.95041 17.608C4.70718 17.5935 4.48249 17.4733 4.33549 17.2789C4.16675 17.0559 4.16675 16.6512 4.16675 15.8419V4.15797Z"
          stroke="white"
          strokeOpacity="0.5"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default PlayIcon;
